const CITY_MUTATION_TYPES = Object.freeze({
  APPEND_CITIES: 'APPEND_CITIES',

  SET_ERROR: 'SET_ERROR',
});

export default CITY_MUTATION_TYPES;
